import { ColumnNames } from "./form.constants";

export const TITULOS_USUARIO_COLUMN_NAMES: ColumnNames[] = [
  // { name: "cod_titulo", label: "Cód. Título" },
  { name: "idtitulo", label: "Cod" , allowFilter:true},
  { name: "dni", label: "Dni" },
  { name: "descripcion", label: "Descripcion" , allowFilter:true},
  { name: "nro_registro", label: "Nro. Registro" , allowFilter:true},
  { name: "estado", label: "Estado" , allowFilter:true}
]
